import {
	FETCH_INSIGHTS_FAILURE,
	FETCH_INSIGHTS_SUCCESS,
	RESET_INSIGHTS,
} from './insightsSaga';

const initialState = {
	data: null,
	error: null,
};

export default function insightReducer(state = initialState, action: any) {
	switch (action.type) {
		case FETCH_INSIGHTS_SUCCESS:
			return { ...state, data: action.payload, error: null };
		case FETCH_INSIGHTS_FAILURE:
			return { ...state, error: action.payload, data: null };
		case RESET_INSIGHTS:
			return initialState;
		default:
			return state;
	}
}
